/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[idpOpenNewWindow]'
})
export class OpenNewWindowDirective {
  @Input() redirectUrl = '';
  @Input() post: any = {};

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click') redirectPageToNewWindowOnClick() {
    if (this.post) {
      this.goToLinkWithPost(this.post);
    } else {
      window.open(this.redirectUrl, '_blank');
    }
  }

  goToLinkWithPost(post: any) {
    const form = this.renderer.createElement('form');

    this.renderer.setProperty(form, 'ngNoForm', true);
    this.renderer.setAttribute(form, 'action', this.redirectUrl);
    this.renderer.setAttribute(
      form,
      'enctype',
      'application/x-www-form-urlencoded'
    );

    this.renderer.setAttribute(form, 'class', 'toExternalPage');
    this.renderer.setAttribute(form, 'target', '_blank');
    this.renderer.setAttribute(form, 'method', 'POST');

    this.createInputs(form, post);

    this.renderer.appendChild(this.el.nativeElement, form);

    form.submit();
  }

  /**
   * Data object should have properties with the type FieldItem from models
   */
  createInputs(form: HTMLFormElement, data: any) {
    for (const property in data) {
      if (data?.property) {
        const input = this.renderer.createElement('input');
        this.renderer.setAttribute(input, 'type', 'hidden');
        this.renderer.setAttribute(input, 'name', data?.property.id);
        this.renderer.setAttribute(input, 'value', data[property].value);

        this.renderer.appendChild(form, input);
      }
    }
  }
}
